
import game.Game
import game.Room
import game.entity.AnimationEntity
import game.entity.Entity

class ShardDoor: Entity(width = 1, height = 1) {
    private var shardCount = 0

    override fun onInit(game: Game, room: Room) {
        shardCount = params.toInt()
        sprite = game.getSpriteById("shard-door")
    }
    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        game.message = game.text("Message_Door_ShardCount", shardCount)

        return false
    }

    override fun onTick(game: Game, room: Room) {
        if (game.shards >= shardCount) {
            game.playSound(game.getSound("door-open"))

            val dust = AnimationEntity()
            dust.params = "dust"
            dust.col = col
            dust.row = row

            room.addEntity(dust)

            room.removePermanently(game, this)
        }
    }
}